/*!
 * STYRKR — Welcome Kit — Shared behaviour
 * Sticky mobile bar reveal, ladder→sticky variant sync, live viewers counter.
 * No .wk-root wrapper required — queries against document.
 */
(function () {
  /* Only run on pages that actually contain the welcome kit sticky bar */
  if (!document.querySelector('.wk-sticky[data-sticky]')) return;

  /* ---- Sticky bar reveal when primary hero CTA scrolls out ---- */
  var primaryCta = document.querySelector('[data-cta-primary]');
  var sticky     = document.querySelector('[data-sticky]');
  if (primaryCta && sticky && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          sticky.classList.remove('is-visible');
          sticky.setAttribute('aria-hidden', 'true');
        } else {
          sticky.classList.add('is-visible');
          sticky.setAttribute('aria-hidden', 'false');
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -40% 0px' });
    io.observe(primaryCta);
  }

  /* ---- Ladder choice → update ladder form quantity + sticky bar ----
     All tiers POST the same variant id; quantity is what drives the
     server-side Shopify Function to apply the correct tier pricing. */
  var ladderInputs   = document.querySelectorAll('[data-ladder-input]');
  var ladderQty      = document.querySelector('[data-ladder-quantity]');
  var stickyVariant  = document.querySelector('[data-sticky-variant]');
  var stickyQuantity = document.querySelector('[data-sticky-quantity]');
  var stickyPrice    = document.querySelector('[data-sticky-price]');
  var stickyWas      = document.querySelector('[data-sticky-was]');

  ladderInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      var qty   = input.getAttribute('data-quantity') || '1';
      var price = input.getAttribute('data-price');
      var was   = input.getAttribute('data-was');
      if (ladderQty)       ladderQty.value = qty;
      if (stickyVariant)   stickyVariant.value = input.value;
      if (stickyQuantity)  stickyQuantity.value = qty;
      if (stickyPrice && price) stickyPrice.textContent = '£' + price;
      if (stickyWas && was)     stickyWas.textContent   = 'was £' + was;
    });
  });

  /* ---- Live viewers popup — rotating count ---- */
  var viewersEl    = document.querySelector('[data-viewers]');
  var viewersCount = document.querySelector('[data-viewers-count]');
  if (viewersEl && viewersCount) {
    var min = parseInt(viewersEl.getAttribute('data-viewers-min') || '12', 10);
    var max = parseInt(viewersEl.getAttribute('data-viewers-max') || '30', 10);
    if (isNaN(min) || isNaN(max) || min >= max) { min = 12; max = 30; }

    var current = parseInt(viewersCount.textContent, 10) || min + 8;

    function nextCount() {
      var delta = Math.floor(Math.random() * 5) - 2;
      var next = current + delta;
      if (next < min) next = min + Math.floor(Math.random() * 3);
      if (next > max) next = max - Math.floor(Math.random() * 3);
      return next;
    }

    function tick() {
      var n = nextCount();
      if (n === current) n = current + (Math.random() > 0.5 ? 1 : -1);
      current = Math.max(min, Math.min(max, n));
      viewersCount.style.opacity = '0';
      setTimeout(function () {
        viewersCount.textContent = current;
        viewersCount.style.opacity = '1';
      }, 240);
    }

    setTimeout(function schedule() {
      tick();
      setTimeout(schedule, 6000 + Math.random() * 8000);
    }, 5000);
  }
}());
